import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { _, TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { menuItems, menuLabels } from './app.navigation';

import { toSignal } from '@angular/core/rxjs-interop';
import { SanctumAuthService } from '@fsf/auth';
import { SidebarLayoutComponent } from '@fsf/ui';
import { map } from 'rxjs';
import { links } from './custom-preset';
import { UserService } from './shared/services/user.service';

_([
  'meta.title',
  'meta.description',
  'meta.keywords',
  'meta.ogTitle',
  'meta.ogDescription',
  'meta.ogSiteName',
]);

@Component({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ButtonModule,
    SidebarLayoutComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  #router = inject(Router);
  #meta = inject(Meta);
  #translate = inject(TranslateService);
  #auth = inject(SanctumAuthService);
  #user = inject(UserService);

  isAuthenticated = this.#auth.isAuth;
  links = links;

  menuItems = toSignal(
    this.#translate.stream(menuLabels).pipe(
      map((translations) => [
        ...menuItems.map((item) => ({
          ...item,
          label: translations[item.label as string],
        })),
      ]),
    ),
    { initialValue: [] },
  );

  items = computed(() => (this.#auth.isAuth() ? this.menuItems() : []));

  constructor() {
    // loadMessages({
    //   en: {
    //     ...enMessages.en,
    //     'dxChat-elementAriaLabel': 'Comments',
    //     'dxChat-textareaPlaceholder': 'Type a comment',
    //     'dxChat-messageListAriaLabel': 'Comment list',
    //     'dxChat-emptyListMessage': 'There are no comments',
    //     'dxChat-emptyListPrompt': 'Write your first comment',
    //   },
    // });
    // locale(navigator.language);
  }

  ngOnInit(): void {
    this.#translate
      .get([
        'meta.title',
        'meta.description',
        'meta.keywords',
        'meta.ogTitle',
        'meta.ogDescription',
        'meta.ogSiteName',
      ])
      .subscribe((metaTranslations) => {
        this.setMetaTags(metaTranslations);
      });
  }

  logout(e?: any): void {
    this.#auth.signOut().subscribe(() => {
      this.#user.clearUser();
      this.#router.navigate(['/login']);
    });
  }

  private setMetaTags(metaTranslations: Record<string, string>): void {
    if (
      this.#meta.getTag('name="title"') &&
      this.#meta.getTag('name="description"') &&
      this.#meta.getTag('name="keywords"') &&
      this.#meta.getTag('property="og:title"') &&
      this.#meta.getTag('property="og:description"') &&
      this.#meta.getTag('property="og:site_name"')
    ) {
      this.#meta.updateTag(
        { content: metaTranslations['meta.title'] },
        'name="title"',
      );
      this.#meta.updateTag(
        { content: metaTranslations['meta.description'] },
        'name="description"',
      );
      this.#meta.updateTag(
        { content: metaTranslations['meta.keywords'] },
        'name="keywords"',
      );
      this.#meta.updateTag(
        { content: metaTranslations['meta.ogTitle'] },
        'property="og:title"',
      );
      this.#meta.updateTag(
        { content: metaTranslations['meta.ogDescription'] },
        'property="og:description"',
      );
      this.#meta.updateTag(
        { content: metaTranslations['meta.ogSiteName'] },
        'property="og:site_name"',
      );
    }
  }
}
